export default __webpack_public_path__ + "db2b95b430da6ea1950ba2cd0f29ff2b.png";